import { imageUrl } from "@/utils/urls";

export const EMPTY_IMAGE = imageUrl('/img/empty.png');
